import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ClaimDocMetadata, ClaimsViewModel } from "../model/claims-view.model";
import { ClaimBulkDocMetadataHandler } from "src/app/add-doc-metadata/services/add-doc-metadata-bulk-claim.interface";
import { newCatSystemVersion } from "@shared/models/common";
import { DocMetadata, DocMetadataGroup, EntityType } from "src/app/add-doc-metadata/model/doc-metadata";


@Component({
    selector: 'claim-bulk-metadata',
    templateUrl: './claim-bulk-metadata.component.html',
    styleUrls: ['./claim-bulk-metadata.component.scss'],
    standalone: false,
    providers: [
        { provide: ClaimBulkDocMetadataHandler, useClass: ClaimBulkDocMetadataHandler }
    ]
})
export class ClaimBulkMetadata implements OnInit, OnChanges {

    @Input() selectedClaims: ClaimsViewModel[] = [];
    //@Input() claimDocMetadata: ClaimDocMetadata[] = [];
    @Input() envId!: number;
    @Input() lang!: string;
    @Input() catVersionId!: number;
    @Input() catSystemVersion!: number;
    @Input() entityType!: EntityType;


    newCatSystemVersion = newCatSystemVersion;
    groups: DocMetadataGroup[] | null= null;
    docMetadataByGroup: {[group: string]: DocMetadata[]} | null = null;

    claimDocMetadata: ClaimDocMetadata[] = [];
    hasChanges: boolean = false;
    isValid: boolean = true;
    isLoading: boolean = false;

    notValidGroups: Set<string> = new Set();

    constructor(private claimBulkDocMetadataHandler: ClaimBulkDocMetadataHandler) {

    }   
    
    ngOnChanges(changes: SimpleChanges): void {

        if (changes['selectedClaims'] && changes['selectedClaims'].currentValue != undefined) {

            this.claimDocMetadata = this.selectedClaims.reduce((acc, selectedClaim) => acc.concat(selectedClaim.metadata), [] as ClaimDocMetadata[]);
            this.claimBulkDocMetadataHandler.claimDocMetadata = this.claimDocMetadata;
            this.claimBulkDocMetadataHandler.selectedClaimsNum = this.selectedClaims.length;
            this.isLoading = true;
            this.claimBulkDocMetadataHandler.getDocMetadataDefinition(this.envId, this.catVersionId, this.lang, null, this.entityType).subscribe((metadataInfo) => {

                this.groups = metadataInfo.groups;
                this.docMetadataByGroup = metadataInfo.docMetadataByGroup;                
                this.isLoading = false;
            }, (error) => this.isLoading = false)

        }
    }
    
    
    ngOnInit(): void {

    }

    get selections() {
        return this.claimBulkDocMetadataHandler.selections;
    }

    get docMetadataToAdd() {
        return this.claimBulkDocMetadataHandler.getDocMetadataToAdd();
    }

    canSubmit() {
        
        return this.isValid && this.hasChanges;
    }

    setValid() {

/*         let notValidGroup = this.groups?.find((group) => {
            if (group.isRequired) {
                
                let groupSelection = this.claimBulkDocMetadataHandler.selections[group.groupName];
                if (Array.isArray(groupSelection) && groupSelection.length == 0) {

                    return true;
                } else if (!Array.isArray(groupSelection) && groupSelection == null) {

                    return true;
                }

            }
            return false;
        })
       this.isValid = notValidGroup == undefined; */
       this.isValid = this.notValidGroups.size == 0;
    }

    setGroupValid(group: DocMetadataGroup) {
        
        let isValidGroup: boolean = true;
        if (group.isRequired) {
            
                let groupSelection = this.claimBulkDocMetadataHandler.selections[group.groupName];
                if (Array.isArray(groupSelection) && groupSelection.length == 0) {

                    isValidGroup = false;
                } else if (!Array.isArray(groupSelection) && groupSelection == null) {

                    isValidGroup = false;
                }

        }
        if (!isValidGroup) {

            this.notValidGroups.add(group.groupName)
        } else {
            this.notValidGroups.delete(group.groupName);
        }
        this.setValid();
    }

    changeSelection(group: DocMetadataGroup) {

        if (group.isMultiValued) {
            if (this.claimBulkDocMetadataHandler.selections[group.groupName] == null) {

                this.claimBulkDocMetadataHandler.selections[group.groupName] = [];
            }            
        }
        this.setGroupValid(group);
        
/*         if (!this.isValid) {
            return;
        } */
        this.checkChanges();
        
    } 
    checkChanges() {
         this.hasChanges = Object.keys(this.claimBulkDocMetadataHandler.selections).find((group) =>{
            
            let groupSelection = this.claimBulkDocMetadataHandler.selections[group];


            let initialSelectionForGroup = this.claimBulkDocMetadataHandler.initialSelections[group]
            if (Array.isArray(groupSelection)) {

                
                if (!this.claimBulkDocMetadataHandler.isEqualDocMetadata(groupSelection, initialSelectionForGroup as DocMetadata[])) {
                    
                    return true;
                }

            }
            if (!Array.isArray(groupSelection)) {
                
                if (!initialSelectionForGroup && !groupSelection) {
                    return false;
                }
                if ((!initialSelectionForGroup && groupSelection) || (initialSelectionForGroup && !groupSelection) || ((initialSelectionForGroup as DocMetadata).fieldLabel != (groupSelection as DocMetadata).fieldLabel)) { 
                    
                    return true;
                }
            }
            return false;
        }) != undefined
    }
    toggleLockValue(group: DocMetadataGroup) {

        this.claimBulkDocMetadataHandler.toggleLockValue(group.groupName);
        this.checkChanges();
    }
}